import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Store } from '@ngxs/store';
import { SupplierBuyerSaleDetailsComponent } from 'src/app/inventory/components/supplier-buyer-sale-details/supplier-buyer-sale-details.component';
import { ICollectOrderDetailsFormValue } from 'src/app/inventory/interfaces/ICollectOrderDetailsFormValue';
import { OrderPartyDetail } from 'src/app/inventory/interfaces/order-party-details.interface';
import { highlightRequiredControlsWithErrors } from 'src/app/shared/helpers/helpers';
import { FormattedDatePipe } from 'src/app/shared/pipes/formatted-date/formatted-date.pipe';
import { GetWholesalersList } from 'src/app/shared/states/profile/profile.actions';
import { ProfileState } from 'src/app/shared/states/profile/profile.state';

@UntilDestroy()
@Component({
  selector: 'app-order-form',
  templateUrl: './order-form.component.html',
  styleUrls: ['./order-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderFormComponent implements OnInit {
  private _initialValue: ICollectOrderDetailsFormValue;

  @Input()
  get initialValue(): ICollectOrderDetailsFormValue {
    return this._initialValue;
  }

  set initialValue(value: ICollectOrderDetailsFormValue) {
    if(value) {
      this._initialValue = {...value, 
        shipDate: value?.shipDate ? new Date(value.shipDate) : undefined,
        buyerDetails: value?.buyerDetails,
        supplierDetails: value?.supplierDetails
      };
      this.form.patchValue({...value, 
        shipDate: this.formattedDatePipe.transform(value?.shipDate, 'MM/dd/yyyy'),
        buyerDetailId: value?.buyerDetails?.id,
        supplierDetailId: value?.supplierDetails?.id
      });
      this.buyer = value?.buyerDetails;
      this.supplier = value?.supplierDetails;
    }
  }
  
  form: UntypedFormGroup;

  buyer: OrderPartyDetail;
  supplier: OrderPartyDetail;
  
  @ViewChild('supplierBuyerDetails') supplierBuyerDetails: SupplierBuyerSaleDetailsComponent;

  constructor(private store: Store, private fb: UntypedFormBuilder, private formattedDatePipe: FormattedDatePipe, private cdr: ChangeDetectorRef) {
    this.form = this.fb.group({
      poNumber: ['', [Validators.required]],
      invoiceNumber: '',
      shipDate: ['', [Validators.required]],
      csos: '',
      buyerDetailId: [null, [Validators.required]],
      supplierDetailId: [null, [Validators.required]],
    });
   }

  ngOnInit(): void {
    if(!this.store.selectSnapshot(ProfileState.wholesalers)?.length) {
      this.store.dispatch(new GetWholesalersList());
    }
  }

  setSupplier(supplier: OrderPartyDetail): void {
    this.supplier = supplier;
    this.form.get('supplierDetailId').patchValue(supplier?.id);
  }

  setBuyer(buyer: OrderPartyDetail): void {
    this.buyer = buyer;
    this.form.get('buyerDetailId').patchValue(buyer?.id);
  }
  
  markForCheck(): void {
    this.cdr.markForCheck();
  }

  highlightRequiredControlsWithErrors(): void {
    highlightRequiredControlsWithErrors(this.form);
    this.cdr.markForCheck();
  }

  now(): Date {
    return new Date();
  }

}
